import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { LEGAL, BRAND } from "../data/content";

export default function Legal() {
  const { type } = useParams();
  const doc = LEGAL[type] || LEGAL.privacy;
  const [active, setActive] = useState(0);
  const key = type || "privacy";

  useEffect(() => {
    const onScroll = () => {
      const tops = doc.sections.map((_, i) => {
        const el = document.getElementById(`sec-${i}`);
        return el ? el.getBoundingClientRect().top : Infinity;
      });
      const idx = tops.findIndex((t) => t > 120);
      setActive(idx === -1 ? doc.sections.length - 1 : Math.max(0, idx - 1));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [doc]);

  const jump = (i) => document.getElementById(`sec-${i}`)?.scrollIntoView({ behavior: "smooth" });

  return (
    <main data-testid="legal-page" className="bg-ivory">
      <div className="h-[76px] bg-navy" />
      <header className="bg-navy grain pt-16 pb-20">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <Reveal>
            <p className="overline text-gold mb-6">{BRAND.name}</p>
            <h1 className="font-serif text-ivory text-5xl md:text-7xl">{doc.title}</h1>
            <div className="gold-line w-24 my-6" />
            <p className="text-ivory/50 text-sm">Last Updated: {doc.updated}</p>
          </Reveal>
        </div>
      </header>

      <div className="max-w-[1100px] mx-auto px-6 md:px-10 py-20 grid md:grid-cols-[220px_1fr] gap-14">
        {/* Index */}
        <aside className="hidden md:block">
          <div className="sticky top-28">
            <p className="overline text-charcoal/50 mb-5">On This Page</p>
            <ul className="space-y-3">
              {doc.sections.map((s, i) => (
                <li key={i}>
                  <button onClick={() => jump(i)} data-testid={`legal-index-${i}`}
                    className={`text-left text-sm leading-snug transition-colors ${active === i ? "text-gold" : "text-charcoal/55 hover:text-navy"}`}>
                    {s.h}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        {/* Mobile jump */}
        <div className="md:hidden mb-4">
          <select onChange={(e) => jump(Number(e.target.value))} data-testid="legal-mobile-jump" className="w-full border border-navy/20 bg-white px-4 py-3 text-sm text-navy">
            <option>Jump to section…</option>
            {doc.sections.map((s, i) => <option key={i} value={i}>{s.h}</option>)}
          </select>
        </div>

        {/* Content */}
        <article className="max-w-[720px]">
          {doc.sections.map((s, i) => (
            <section key={i} id={`sec-${i}`} className="mb-12 scroll-mt-28">
              <h2 className="font-serif text-2xl md:text-3xl text-navy">{s.h}</h2>
              <div className="gold-line w-16 my-4 !bg-gold/50" style={{ background: "#D4AF37" }} />
              <p className="text-charcoal/75 leading-[1.9] text-[15px]">{s.p}</p>
            </section>
          ))}

          <div className="border-t border-navy/10 pt-8 mt-8 flex flex-wrap gap-6 items-center">
            <span className="overline text-charcoal/50">Also read:</span>
            {["privacy", "terms", "refund"].filter((t) => t !== key).map((t) => (
              <Link key={t} to={`/legal/${t}`} className="text-navy link-underline text-sm">{LEGAL[t].title}</Link>
            ))}
            <Link to="/enquire" className="btn-gold !py-2.5 !px-6 ml-auto">Contact Us</Link>
          </div>
        </article>
      </div>
    </main>
  );
}
